import { useEditorStore } from '@/features/editor/stores/mobx/editor-store';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { NumberField } from '@/components/number-field/number-field';
import { FormattedMessage } from 'react-intl';

export const EsdecPurlinDistanceInput = observer(function EsdecPurlinDistanceInput({
  surfaceId
}: {
  surfaceId: string;
}) {
  const store = useEditorStore();
  const { surfacesEsdec } = store;

  const surfaceEsdec = surfacesEsdec.surfaces[surfaceId];

  if (!surfaceEsdec) {
    return <React.Fragment />;
  }

  return (
    <NumberField
      isDisabled={surfaceEsdec.isRoofFinalized}
      minValue={865}
      label={<FormattedMessage defaultMessage="Purlin Distance" id="Xzk82M" />}
      formatOptions={{
        style: 'unit',
        unit: 'millimeter'
      }}
      showStepper={true}
      value={surfaceEsdec.purlinDistance}
      onChange={(value) => {
        if (Number.isNaN(value)) {
          return;
        }
        surfaceEsdec.updatePurlinDistance(value);
      }}
    />
  );
});
